// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__y9AO8","col":"styles_col__16mnc"};